import request from "./http";
import qs from 'qs'

//泵站检测->获取泵站设备列表
// 
export function findDeviceList() {
    return request({
        url: "/monitoring/findDevice/list",
        method: "get",
 
    });
}



//泵站检测->根据设备编号获取报告列表
// 
export function findReportList(params) {
    return request({
        url: "/monitoring/findReport/list",
        method: "get",
        params
 
    });
}


//泵站检测->根据报告信息获取报告详情列表
// 
export function findReportDetails(params) {
    return request({
        url: "/monitoring/findReportDetails",
        method: "get",
        params
 
    });
}